import * as parser from "cron-parser";
import cronstrue from "cronstrue";
import { useMemo } from "react";

export const useValidateCron = (cron?: string) => {
  const cronValid = useMemo(() => {
    // check if cron is valid
    if (!cron) return false;
    try {
      parser.parseExpression(cron);
      return true;
    } catch (_e) {
      return false;
    }
  }, [cron]);
  return cronValid;
};

export function getCronInfo(cron?: string) {
  if (!cron)
    return {
      info: "Not scheduled",
      details: "Not scheduled",
      isValid: false,
    };

  try {
    parser.parseExpression(cron);
    return {
      info: `${cronstrue.toString(cron, {
        use24HourTimeFormat: true,
      })} (UTC)`,
      details: `${cronstrue.toString(cron, {
        use24HourTimeFormat: true,
        verbose: true,
      })} (UTC)`,
      isValid: true,
    };
  } catch (error) {
    return {
      info: "Invalid cron expression",
      details:
        error instanceof Error
          ? `Error: ${error.message}`
          : typeof error === "string"
            ? error
            : "Invalid cron expression",
      isValid: false,
    };
  }
}

export const useDisplayCron = (cron?: string) => {
  const { cronDisplay, cronDisplayVerbose, cronValid } = useMemo(() => {
    const { info, details, isValid } = getCronInfo(cron);
    return {
      cronDisplay: info,
      cronDisplayVerbose: details,
      cronValid: isValid,
    };
  }, [cron]);
  return { cronDisplay, cronDisplayVerbose, cronValid };
};
